import styled from "styled-components/macro";
import herobg from "../../Images/herobg.jpg";
export const HeroWrapper = styled.div`
  width: 100%;
  padding: 14rem 0;
  padding-bottom: 12rem;
  position: relative;
  overflow: hidden;
  color: #fbfbfb;
  a {
    margin-right: 2rem;
    z-index: 1;
    margin-bottom: 2rem;
  }
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(${herobg});
    background-position: center;
    background-size: cover;
    z-index: -4;
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    min-width: 30rem;
    background: #030303;
    opacity: 0.5;
    z-index: -3;
    @media screen and (max-width: 820px) {
      width: 100%;
    }
  }
  h1 {
    font-size: 3.6rem;
  }
  h3 {
    font-size: 1.2rem;
    margin-bottom: 2rem;
    font-weight: normal;
    opacity: 0.75;
  }
`;
